// TYPEKIT SCRIPT

(function(d) {
  var config = {
	kitId: 'lwq7mcu',
	scriptTimeout: 3000,
	async: true
  },
  h=d.documentElement,t=setTimeout(function(){h.className=h.className.replace(/\bwf-loading\b/g,"")+" wf-inactive";},config.scriptTimeout),tk=d.createElement("script"),f=false,s=d.getElementsByTagName("script")[0],a;h.className+=" wf-loading";tk.src='https://use.typekit.net/'+config.kitId+'.js';tk.async=true;tk.onload=tk.onreadystatechange=function(){a=this.readyState;if(f||a&&a!="complete"&&a!="loaded")return;f=true;clearTimeout(t);try{Typekit.load(config)}catch(e){}};s.parentNode.insertBefore(tk,s)
})(document);

// OPEN / CLOSE DESKTOP NAV
jQuery(document).ready(function( $ ) {
	$('.nav-trigger').on('click', function(e) {
	  $('.desktop-nav').toggleClass("active");
	  $('.nav-trigger').toggleClass("active");
	  e.preventDefault();
	});
});

// SMOOTH SCROLL TO ACNCHORS
jQuery(function($) {

$('a[href^="#"]').on('click',function(event){
    event.preventDefault();
    var target_offset = $(this.hash).offset() ? $(this.hash).offset().top : 0;
    //change this number to create the additional off set
    var customoffset = 0;
    $('html, body').animate({scrollTop:target_offset - customoffset}, 500);
});

}(jQuery));